import React, { useId } from 'react'
import PropTypes from 'prop-types'

const PauseIcon = React.forwardRef(function PauseIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M17 2C15.35 2 14 3.35 14 5V19C14 20.65 15.35 22 17 22 18.65 22 20 20.65 20 19V5C20 3.35 18.65 2 17 2ZM7 2C5.35 2 4 3.35 4 5V19C4 20.65 5.35 22 7 22 8.65 22 10 20.65 10 19V5C10 3.35 8.65 2 7 2Z"></path>
    </svg>
  )
})

PauseIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

PauseIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default PauseIcon
